import { render, staticRenderFns } from "./FinancingSantander.vue?vue&type=template&id=528677ab&scoped=true&"
import script from "./FinancingSantander.vue?vue&type=script&lang=js&"
export * from "./FinancingSantander.vue?vue&type=script&lang=js&"
import style0 from "./FinancingSantander.vue?vue&type=style&index=0&id=528677ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528677ab",
  null
  
)

export default component.exports